import React, {useEffect, useState} from 'react'
import {useFormik} from 'formik'
import {TextInput} from '../../../../components/inputs/TextInput'
import {createEquipe, editEquipe} from '../../../../components/requests'
import {useNavigate} from 'react-router-dom'

const validate = (values) => {
  const errors: {nom?: string} = {}
  if (!values.nom) {
    errors.nom = 'Le libellé est requis'
  }
  return errors
}

const EquipeForm = ({id, data}) => {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const navigate = useNavigate()

  const insertOrUpdateEquipe = (values) => {
    let action
    if (data === null) {
      action = createEquipe(values)
    } else {
      action = editEquipe(id, values)
    }
    action
      .then((response) => {
        if (response?.data !== undefined && response?.status === 200) {
          setIsLoading(false)
          navigate('/equipes/liste')
        }
      })
      .catch((error) => {
        console.log('erreur')
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  const submitEquipe = (values) => {
    setIsLoading(true)
    insertOrUpdateEquipe(values)
  }

  useEffect(() => {
    if (data !== null) {
      formik.setFieldValue('nom', data.nom)
    }
  }, [data])

  const formik = useFormik({
    initialValues: {
      nom: '',
    },
    validate,
    onSubmit: (values) => {
      submitEquipe(values)
    },
  })

  return (
    <div>
      <form onSubmit={formik.handleSubmit} noValidate className='form'>
        <div className='card-body border-top p-9'>
          <div className='row mb-6'>
            <label className='col-lg-4 col-form-label required fw-bold fs-6'>Libellé</label>
            <div className='col-lg-8'>
              <div className='row'>
                <div className='col-lg-6 fv-row'>
                  <TextInput
                    fieldName={'nom'}
                    inputPlaceholder={'Libellé'}
                    inputType={'text'}
                    inputClassName={'form-control form-control-lg form-control-solid mb-3 mb-lg-0'}
                    formik={formik}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='card-footer d-flex justify-content-end py-6 px-9'>
          <button
            type='button'
            className='btn btn-light me-3'
            onClick={() => {
              formik.resetForm()
              navigate(`/equipes/liste`)
            }}
          >
            Annuler
          </button>
          <button type='submit' className='btn btn-primary'>
            {isLoading ? (
              <span className='indicator-progress' style={{display: 'block'}}>
                Enregistrement...{' '}
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
              </span>
            ) : (
              'Enregistrer'
            )}
          </button>
        </div>
      </form>
    </div>
  )
}

export {EquipeForm}
